import { DateTime } from 'luxon'

// Same thresholds as the backend's StudentInsights::Reason#cadence, so this
// matches the pace in the reason line shown above it.
export const formatCadence = days => {
  if (!days) return 'Not enough lessons yet'
  if (days === 7) return 'Every week'
  if (days < 14) return `Every ${days} ${days === 1 ? 'day' : 'days'}`
  const weeks = Math.round(days / 7)
  return weeks < 8
    ? `Every ${weeks} weeks`
    : `Every ${Math.round(days / 30)} months`
}

export const formatCents = cents =>
  cents == null
    ? '—'
    : new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      maximumFractionDigits: 0,
    }).format(cents / 100)

export const formatLessonDate = iso => {
  if (!iso) return 'None'
  const date = DateTime.fromISO(iso)
  const format = date.hasSame(DateTime.local(), 'year')
    ? 'LLL d'
    : 'LLL d, yyyy'
  return date.toFormat(format)
}
